import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const taxApi = createApi({
  reducerPath: 'taxApi',
  baseQuery,
  tagTypes: ['TaxConfiguration'],
  endpoints: (builder) => ({
    // Get all tax configurations
    getTaxConfigurations: builder.query({
      query: (params = {}) => ({
        url: '/tax',
        method: 'GET',
        params: {
          page: params.page || 1,
          limit: params.limit || 10,
          country: params.country,
          state: params.state,
          taxType: params.taxType,
          isActive: params.isActive !== undefined ? params.isActive : true,
        },
      }),
      providesTags: ['TaxConfiguration'],
    }),

    // Get single tax configuration
    getTaxConfiguration: builder.query({
      query: (id) => `/tax/${id}`,
      providesTags: (result, error, id) => [{ type: 'TaxConfiguration', id }],
    }),

    // Create tax configuration
    createTaxConfiguration: builder.mutation({
      query: (taxData) => ({
        url: '/tax',
        method: 'POST',
        body: taxData,
      }),
      invalidatesTags: ['TaxConfiguration'],
    }),

    // Update tax configuration
    updateTaxConfiguration: builder.mutation({
      query: ({ id, ...taxData }) => ({
        url: `/tax/${id}`,
        method: 'PUT',
        body: taxData,
      }),
      invalidatesTags: ['TaxConfiguration'],
    }),

    // Delete tax configuration
    deleteTaxConfiguration: builder.mutation({
      query: (id) => ({
        url: `/tax/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TaxConfiguration'],
    }),

    // Calculate tax
    calculateTax: builder.mutation({
      query: (calculationData) => ({
        url: '/tax/calculate',
        method: 'POST',
        body: calculationData,
      }),
    }),

    // Get tax types by country
    getTaxTypesByCountry: builder.query({
      query: (country) => `/tax/types/${country}`,
    }),

    // Get states by country
    getStatesByCountry: builder.query({
      query: (country) => `/tax/states/${country}`,
    }),
  }),
});

export const {
  useGetTaxConfigurationsQuery,
  useGetTaxConfigurationQuery,
  useCreateTaxConfigurationMutation,
  useUpdateTaxConfigurationMutation,
  useDeleteTaxConfigurationMutation,
  useCalculateTaxMutation,
  useGetTaxTypesByCountryQuery,
  useGetStatesByCountryQuery,
} = taxApi;
